import React, { useState } from "react";
import styled from "styled-components";
import Img from "gatsby-image";

import Wrapper from "../components/styled/wrapper";
import ToggleButton from "../components/styled/ToggleButton";
import colors from "../styles/colors";

const Employee = ({ employee }) => (<EmployeeStyle>
  {
    employee.frontmatter.image && (
      employee.frontmatter.image.childImageSharp ? (
        <ProfilePicture
          fixed={employee.frontmatter.image.childImageSharp.fixed}
          alt={employee.frontmatter.image.title}
        />
      ) : (
        <ProfilePicture
          as="div"
          style={{ backgroundImage: `url(${employee.frontmatter.image.path})` }}
        />
      )
    )}
  <p className="h4">{employee.frontmatter.name}</p>
  <p>{employee.frontmatter.position} {employee.frontmatter.department && `- ${employee.frontmatter.department}`}</p>
  <p><a href={`tel: ${employee.frontmatter.phone.replace(/\D/g, '')}`}>{employee.frontmatter.phone}</a></p>
  <p><a href={`mailto: ${employee.frontmatter.email}`}>{employee.frontmatter.email}</a></p>
</EmployeeStyle>);

export default ({ employees, title, preview = false }) => {
  const [showAll, setShowAll] = useState(false);
  const allDepartments = employees
    .reduce((departments, employee) => {
      const key = employee.frontmatter.department || 'Andra';
      console.log(employee);
      return {
        ...departments,
        [key]: [...departments[key] || [], employee]
      }
    }, {});
  console.log(allDepartments);
  return (
    <Container>
      {title && <h2>{title}</h2>}
      <Grid>
        {!showAll && employees
          .filter(employee => employee.frontmatter.featured)
          .map(employee => (
            <Employee key={employee.frontmatter.email} employee={employee} />
          ))}
      </Grid>
      <Grid>
        {/* {showAll && Object.keys(departments).map((key)=> department.key)
          .map(employee => (
            <Employee key={employee.frontmatter.email} employee={employee} />
          ))} */}
        {showAll && Object.keys(allDepartments)
          .map((department) => <>
            <h3 style={{ width: '100%', textAlign: 'center' }} key={department}>{department}</h3>
            {allDepartments[department].map(employee => (
              <Employee key={employee.frontmatter.email} employee={employee} />
            ))}
          </>
          )}
        {/* .map((department)=> <p key={department}>{department}</p>)} */}
      </Grid>

      {preview === false && !showAll && (<ToggleButton onClick={() => setShowAll(true)}>Visa fler</ToggleButton>)}
      {preview === false && showAll && (<ToggleButton onClick={() => setShowAll(false)}>Visa färre</ToggleButton>)}
    </Container>
  );
}

const Container = styled(Wrapper)`
  padding: 6rem 0;
  max-width: 70rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  > h2 {
    margin-top: 0;
  }
`

const Grid = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 2rem;
  width: 100%;
`

const EmployeeStyle = styled.div`
  /* margin: 0 2rem; */
  margin-bottom: 3rem;
  width: 17rem;
  padding: 0 3rem;
  max-width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  > p {
    text-align: center;
    margin: 0;
  }
`
const ProfilePicture = styled(Img)`
  border-radius: 50%;
  width: 80px;
  height: 80px;
  background-position: center;
  background-size: cover;
  display: block;
`
